/* eslint-disable @typescript-eslint/dot-notation */
import {ModalComponents} from 'constants/Modals';

import Icon from 'components/Icon/Icon';
import TemplateInput from 'features/postGenerator/shared/TemplateInput/TemplateInput';
import {setFieldsAC, setSingleFieldAC} from 'features/postGenerator/slice';
import {IField, postGeneratorSteps} from 'features/postGenerator/typescript';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import cloneDeep from 'lodash.clonedeep';
import {batch} from 'react-redux';
import {setModalAC} from 'store/modal/modalSlice';
import {PubBeer} from 'typescript/models/PubBeer';

import './Standard.scss';
import TemplateBeer from '../../shared/TemplateBeer/TemplateBeer';

interface IProps {
  frontPage: boolean;
  beers: PubBeer[];
}
export default function Standard({frontPage, beers}: IProps) {
  const {postType, fields, step, isPriceChecked} = useGlobalState((state) => state.postGenerator);
  const {managedPub} = useGlobalState((state) => state.managedPub);
  const {countryHash} = useGlobalState((state) => state.app);
  const dispatch = useSetGlobalState();

  const {pub_logo} = managedPub?.attributes || {};
  const isNotSelectPostType = step !== postGeneratorSteps.postType;
  const onEditClick = (field: IField) => {
    dispatch(setModalAC(ModalComponents.TEMPLATE_STYLE));

    const fieldsCopy = cloneDeep(fields);
    const foundField = fieldsCopy.find((x) => x.id === field.id);

    if (!foundField) {
      fieldsCopy.push(field);
    }

    batch(() => {
      dispatch(setFieldsAC(fieldsCopy));
      dispatch(setSingleFieldAC(foundField || field));
    });
  };

  return (
    <div className={`template-standard template-standard--${postType} `}>
      {frontPage ? (
        <div
          className={`template-standard__wrap ${!isPriceChecked ? 'template-standard__wrap--remove-price' : ''} ${
            isNotSelectPostType ? '' : 'template-standard__wrap--remove-layout'
          }`}
        >
          <div className="template-standard__front">
            <div className="template-standard__info">
              <div className="template-standard__content">
                <div className="template-standard__logo">
                  {pub_logo ? (
                    <img src={pub_logo} alt="Classic template pub logo" />
                  ) : (
                    <Icon icon="pub_page-image-placeholder" />
                  )}
                </div>
                <div className="template-standard__title">
                  <TemplateInput
                    className="title"
                    id="title"
                    onEditClick={() => {
                      onEditClick({id: 'title', style: {fontSize: '14'}});
                    }}
                  />
                  <TemplateInput
                    className="subtitle"
                    id="subTitle"
                    onEditClick={() => {
                      onEditClick({id: 'subTitle', style: {fontSize: '14'}});
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="template-standard__beers">
              <div className="template-standard__inner">
                {beers.map((beer) => {
                  return (
                    <TemplateBeer beer={beer} key={beer.id} countryHash={countryHash} showPrice={isPriceChecked} />
                  );
                })}
              </div>
            </div>
          </div>
          {isNotSelectPostType && (
            <footer className="template-standard__footer">Generated by TapSpots {new Date().getFullYear()}</footer>
          )}
        </div>
      ) : (
        <div
          className={`template-standard__wrapper ${!isPriceChecked ? 'template-standard__wrapper--remove-price' : ''} ${
            isNotSelectPostType ? '' : 'template-standard__wrapper--remove-layout'
          }`}
        >
          <div
            className={`template-standard__logo ${isNotSelectPostType ? '' : 'template-standard__logo--remove-logo'}`}
          >
            {pub_logo ? (
              <img src={pub_logo} alt="Classic template pub logo" />
            ) : (
              <Icon icon="pub_page-image-placeholder" />
            )}
          </div>
          <div className="template-standard__page">
            <div className="template-standard__beers-container">
              {beers.map((beer) => {
                return <TemplateBeer beer={beer} key={beer.id} countryHash={countryHash} showPrice={isPriceChecked} />;
              })}
            </div>
          </div>
          {isNotSelectPostType && (
            <footer className="template-standard__footer">Generated by TapSpots {new Date().getFullYear()}</footer>
          )}
        </div>
      )}
    </div>
  );
}
